import React from 'react';

export const RingIcon = ({ bgColor, borderColor }) => (
  <div className="ring-container">
    <div style={{ borderColor }} className="ringring" />
    <div style={{ backgroundColor: bgColor }} className="circle" />
  </div>
);
